import { CrossSellVenueAndAvailability, TimeSlot } from "../types";
import DateHelper from "./DateHelper";

export default class TimeSlotHelper {
  /**
   * Format the time string to be displayed in the format HH:mm using DateHelper.parseTime
   * @param time - The time string to be searched for
   * @param va - The venue and availability data
   * @returns An TimeSlot object containing the MicrositeName and the matched TimeSlot
   */
  static makeTimeSlotAvailabilitySearch = (
    time: React.SetStateAction<string | null>,
    va: CrossSellVenueAndAvailability
  ) => {
    return {
      MicrositeName: va.CrossSellVenue.MicrositeName,
      TimeSlot: va.AvailabilitySearchResponse.TimeSlots.find((t) => {
        if (DateHelper.sliceAvailabilitySearchTimeSlot(t) === time) {
          return t;
        }
      }),
    } as TimeSlot;
  };
}
